module.exports = __webpack_public_path__ + "static/media/TukTuk.ba6a68b0.md";